
// Define enums for event status
export enum EventStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  CANCELLED = 'cancelled',
  ARCHIVED = 'archived',
  POSTPONED = "postponed"
}

export interface CreateEventRequest {
  name: string;
  description: string;
  dateStart: string;
  dateEnd: string;
  venue: {
    city: string;
    name: string;
    address: string;
    region?: string;
    online?: boolean;
    url?: string; // Added for online events
  };
  type: string;
  professions?: string[]; // Changed from targetAudience to professions
  creditPoints?: number | null;
  postAccredited?: boolean;
  maxAttendees?: number;
  imageUrl?: string;
  tags?: string[];
  registrationUrl?: string; // Hozzáadva a regisztrációs URL-hez
  status?: EventStatus; // Add status field
}

export interface EventsQueryParams {
  page?: number;
  itemsPerPage?: number;
  search?: string;
  type?: string;
  audience?: string;
  dateFrom?: string;
  dateTo?: string;
}

// Define types for Hydra responses
export interface HydraItemResponse<T> {
  '@context': string;
  '@id'?: string;
  '@type': string;
}

export interface EventItemResponse extends HydraItemResponse<any>, Event {
}

export interface HydraCollectionResponse<T> {
  '@context': string;
  '@id': string;
  '@type': string;
  'hydra:member': T[];
  'hydra:totalItems': number;
}
